import { useDocumentTitle } from "~/common/use-document-title"

export const AccountSettingsScreen: React.FC = () => {
  useDocumentTitle("Account Settings")

  return (
    <div className="flex flex-1 flex-col min-h-0 bg-stone-50">
      <div className="px-6 py-5 border-b border-stone-200 bg-white">
        <h1
          className="text-sm font-bold text-stone-900"
          style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
        >
          Account Settings
        </h1>
      </div>
      <div className="px-6 py-8 text-sm text-stone-400">
        Manage your location filter and email digest from the left navigation.
      </div>
    </div>
  )
}
